import React, { useEffect, useState } from "react";
import Header from "./../../../component/common/AdminHeader";
import { getDakListAdmin } from "../../../actions/DakManagement";
import { DetailsList } from "@fluentui/react";
import { SelectionMode } from "@fluentui/react/lib/Selection";
import { TooltipHost } from '@fluentui/react/lib/Tooltip';
import moment from "moment";

function getColumnsOutbound() {
  return [
    {
      key: "to",
      name: "To",
      fieldName: "to",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "description",
      name: "Description",
      fieldName: "description",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "awb",
      name: "AWB",
      fieldName: "awb",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "name",
      name: "Created By",
      fieldName: "name",
      minWidth: 200,
      maxWidth: 300,
      isResizable: true,
    },
    {
      key: "createdOn",
      name: "Created On",
      fieldName: "createdOn",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "status",
      name: "Status",
      fieldName: "status",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
  ];
}

function getColumnsInbound() {
  return [
    {
      key: "from",
      name: "From",
      fieldName: "from",
      minWidth: 50,
      maxWidth: 100,
      isResizable: true,
    },
    {
      key: "description",
      name: "Description",
      fieldName: "description",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "awb",
      name: "AWB",
      fieldName: "awb",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "name",
      name: "Created By",
      fieldName: "name",
      minWidth: 200,
      maxWidth: 300,
      isResizable: true,
    },
    {
      key: "createdOn",
      name: "Created On",
      fieldName: "createdOn",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
    {
      key: "status",
      name: "Status",
      fieldName: "status",
      minWidth: 100,
      maxWidth: 200,
      isResizable: true,
    },
  ];
}

function DakAdmin() {
  const [data, setData] = useState(null);

  useEffect(() => {
    getData();
  }, []);

  async function getData() {
    try {
      const { result } = await getDakListAdmin();
      setData(result);
    } catch (e) {
      console.log(e, "error");
    }
  }

  function getMailStatus(item) {
    if (item.type === "Inbound") {
      return item.status ? "Received" : "Not Received";
    }
    if (item.type === "Outbound") {
      return item.status ? "Dispatched" : "Not Dispatched";
    }
  }

  function _renderItemColumn(item, index, column) {
    const fieldContent = item[column.fieldName];

    switch (column.key) {
      case "to":
        return (
          <TooltipHost
          content={fieldContent}
          calloutProps={{gapSpace: 0 }}
          styles={{ root: { display: 'inline-block' } }}
        >
          <span style={{ fontSize: "14px", textAlign: "center" }}>
            {fieldContent.slice(0, 13) || "-"}
          </span>
          </TooltipHost>

        );
      case "description":
        return (
          <TooltipHost
          content={fieldContent}
          calloutProps={{gapSpace: 0 }}
          styles={{ root: { display: 'inline-block' } }}
        >
          <span style={{ fontSize: "14px", textAlign: "center" }}>
            {fieldContent.slice(0, 13) || "-"}
          </span>
          </TooltipHost>

        );
      case "awb":
        return (
          <span style={{ fontSize: "14px", textAlign: "center" }}>
            {fieldContent || "-"}
          </span>
        );
      case "createdOn":
        return (
          <span style={{ fontSize: "14px", textAlign: "center" }}>
            {moment(fieldContent).format("DD-MM-YYYY")}
          </span>
        );
      case "status":
        return (
          <span style={{ fontSize: "14px", textAlign: "center" }}>
            {getMailStatus(item)}
          </span>
        );
      default:
        return (
          <span style={{ fontSize: "14px", textAlign: "center" }}>
            {fieldContent}
          </span>
        );
    }
  }

  return (
    <>
    <style jsx>
      {`
      .ms-DetailsList-headerWrapper .root-64
      {background: linear-gradient(135deg, #3580c3 0%, #056caf 100%) !important; color:#fff;
       padding-top:0px; border-radius: 8px 8px 0px 0px; margin-top:10px;}
      .ms-DetailsList-headerWrapper .root-64 .root-81{color:#fff; background: transparent;}
      `}
    </style>
    <div className="container-fluid h-screen">
      <div className="row h-full overflow-auto">
        {/* <div className="col-md-2 px-0">
          <Header />
        </div> */}
        <div className="col-md-12 h-full">
          <div className="card homedob">
            <div className="row h-10">
              <div className="col-md-12 my-3">
                <h1 className="page-title">Dak List</h1>
              </div>
            </div>
            <div className="h-5/6 mt-3 flex flex-col items-stretch">
              <div className="h-2/4 mb-3">
                <p className="text-base font-semibold">Outbound</p>
                <div className="h-full overflow-auto">
                  <DetailsList
                    items={data ? data.outbound : []}
                    columns={getColumnsOutbound()}
                    onRenderItemColumn={_renderItemColumn}
                    selectionMode={SelectionMode.none}
                  />
                </div>
              </div>
              <div className="h-2/4 mt-3">
                <p className="text-base font-semibold">Inbound</p>
                <div className="h-full overflow-auto">
                  <DetailsList
                    items={data ? data.inbound : []}
                    columns={getColumnsInbound()}
                    onRenderItemColumn={_renderItemColumn}
                    selectionMode={SelectionMode.none}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    </>
  );
}

export default DakAdmin;
